/**
 * @file.
 * Contains socket constants.
 */

export const TRADING_TYPES = {
  OPEN_ORDER: 'OpenOrder',
  CLOSE_ORDER: 'CloseOrder',
  UPDATE_ORDER: 'ModifyOrder',
  MODIFY_ORDER: 'ModifyOrder',
  GET_ACCOUNT: 'GetAccount',
  GET_ORDERS: 'GetOrders',
};

export const PRICING_TYPES = {
  GET_INSTRUMENTS: 'GetInstruments',
  GET_SERVER_TIME: 'GetServerTime',
  TICKS_SUBSCRIBE: 'TicksSubscribe',
  TICKS_UNSUBSCRIBE: 'TicksUnsubscribe',
  LAST_TICKS: 'GetLastTicks',
  GET_CANDLES: 'GetCandles',
};

export const TRADING_STREAM_URL = `${process.env.REACT_APP_WS_URL}/trading`;
export const PRICING_STREAM_URL = `${process.env.REACT_APP_WS_URL}/pricing`;
